import RoadMap from "../components/roadMap/RoadMap"

export const bannerContent = {
    shortHeading: "Web App Development",
    // mainHeadingGreenText: "Services",
    mainHeading: "Trusted by <span>Startups,</span> SMBs, & Enterprises alike",
    description: "As a leading web app development company, Bitsclan IT Solutions provides top-notch web application development services to help you achieve your business goals. We build robust, secure, scalable web applications ensuring reliability & seamless integration.",
    btnText: "Let's Get Started",
}

export const webAppDevelopmentPageServices = {
    shortHeading: "Our Services",
    mainHeading: "Our Expansive Range of End-to-end Web App Development Services",
    description: "Our web application solutions cover everything from custom cloud platforms & interactive portals to seamless front-end & robust back-end development. We deliver secure, scalable solutions designed to evolve with your business, including expert consulting & ongoing support.",
    cardsData: [
        {
            "title": "Custom Web App Development",
            "description": "Tailored web apps built to match your business needs—scalable, secure, & seamlessly integrated to enhance efficiency."
        },
        {
            "title": "Frontend & Backend Development",
            "description": "Full-stack expertise with modern frameworks for engaging frontends & powerful, reliable backends."
        },
        {
            "title": "SaaS & Enterprise Solutions",
            "description": "From SaaS products to enterprise systems, we build multi-tenant, AI-driven solutions for long-term growth."
        },
        {
            "title": "Web Portal Development",
            "description": "Centralized, secure portals that streamline processes, improve collaboration, & boost productivity."
        },
        {
            "title": "Strategic Consulting",
            "description": "Expert guidance on technology, architecture, & security to ensure your web app is future-ready."
        }
    ]
}

export const TypesOfBuildData = {
    mainHeading: "Key Features of High-Quality Web Applications",
    TypesOfBuildDataAccordian: [
        {
            id: "collapseOne",
            question: "Development Services",
            answer: {
                discription:
                    "As a dedicated web app development partner, we take a client-first approach to deliver tailored solutions. By combining modern frameworks, agile methodologies, & innovative thinking, we create web applications that meet your unique business goals with precision, scalability, & unmatched quality.",
                listTitle: "",
                listContent: [],
            },
        },
        {
            id: "collapseTwo",
            question: "Secure",
            answer: {
                discription:
                    "Our secure web applications are built to protect sensitive data & prevent vulnerabilities, ensuring user trust. With encrypted communication & strong authentication protocols, we deliver solutions that safeguard your business & customer information.",
                listTitle: "Our secure web apps are best for:",
                listContent: [
                    {
                        line: "Handling sensitive user or business data",
                    },
                    {
                        line: "Financial & e-commerce transactions",
                    },
                    {
                        line: "Preventing security breaches",
                    },
                    {
                        line: "Ensuring compliance with regulations",
                    },
                    {
                        line: "Building trust with end-users",
                    },
                ],
            },
        },
        {
            id: "collapseThree",
            question: "Fast",
            answer: {
                discription:
                    "Speed drives user satisfaction, & our web apps are engineered to load quickly & perform seamlessly. By using optimized code & advanced frameworks, we create fast & responsive solutions that keep your audience engaged.",
                listTitle: "Our fast web apps are best for:",
                listContent: [
                    {
                        line: "High-traffic platforms",
                    },
                    {
                        line: "Real-time processing requirements",
                    },
                    {
                        line: "Enhancing user experience",
                    },
                    {
                        line: "Reducing bounce rates",
                    },
                    {
                        line: "Delivering quick data updates",
                    },
                ],
            },
        },
        {
            id: "fourth",
            question: "Scalable",
            answer: {
                discription:
                    "Our scalable web apps are designed to grow with your business. With flexible architectures & cloud-based solutions, they handle increasing users, features, & data effortlessly, supporting your success.",
                listTitle: "Our scalable web apps are best for:",
                listContent: [
                    {
                        line: "Startups planning to grow",
                    },
                    {
                        line: "Businesses with fluctuating user loads",
                    },
                    {
                        line: "Multi-functional platforms",
                    },
                    {
                        line: "Handling large-scale operations",
                    },
                    {
                        line: "Future-ready applications",
                    },
                ],
            },
        },
        {
            id: "fifth",
            question: "Robust",
            answer: {
                discription:
                    "We design web apps that are reliable, resilient, & capable of handling heavy workloads. These robust solutions ensure flawless functionality, even under demanding conditions.",
                listTitle: "Our robust web apps are best for:",
                listContent: [
                    {
                        line: "Complex business operations",
                    },
                    {
                        line: "Apps requiring high performance",
                    },
                    {
                        line: "Data-intensive processes",
                    },
                    {
                        line: "Enterprise-grade solutions",
                    },
                    {
                        line: "Long-term durability",
                    },
                ],
            },
        },
        {
            id: "Sixth",
            question: "Responsive",
            answer: {
                discription:
                    "We create web apps that adapt beautifully to any device, offering a consistent & enjoyable experience for users on desktops, tablets, & mobiles.",
                listTitle: "Our responsive web apps are best for:",
                listContent: [
                    {
                        line: "Multi-device accessibility",
                    },
                    {
                        line: "Cross-platform consistency",
                    },
                    {
                        line: "Enhancing user engagement",
                    },
                    {
                        line: "Mobile-first businesses",
                    },
                    {
                        line: "Reaching wider audiences",
                    },
                ],
            },
        },
        {
            id: "seventh",
            question: "User-Friendly",
            answer: {
                discription:
                    "Intuitive & simple, our user-friendly web apps make navigation a breeze. Designed with the end-user in mind, they enhance engagement & ensure satisfaction at every step.",
                listTitle: "Our user-friendly web apps are best for:",
                listContent: [
                    {
                        line: "Simplifying complex tasks",
                    },
                    {
                        line: " Improving user retention",
                    },
                    {
                        line: "Creating delightful experiences",
                    },
                    {
                        line: "Catering to non-technical users",
                    },
                    {
                        line: "Enhancing brand loyalty",
                    },
                ],
            },
        },
    ]
}

export const WhoWeServeData = {
    WhoWeServeSectionContent: {
        mainHeading: "Who We Serve",
        sectionDescription: "With our advanced web app development services, we empower businesses to harness the latest technologies. Whether it’s Artificial Intelligence, Internet of Things, or Blockchain, we build solutions that transform ideas into impactful realities. No matter your industry, we deliver results tailored to your needs & vision."
    },
    WhoWeServeCards: [
        {
            icon: "/images/servie-icon/startups.svg",
            title: "Startups",
            description:
                "For startups, every step counts. We help early-stage ventures by developing cost-effective & scalable apps that bring their ideas to life. Whether you need an MVP to attract investors or a feature-rich product to launch in the market, we ensure your solution stands out & grows alongside your business.",
            link: "#",
            borderClass: "border-1",
        },
        {
            icon: "/images/servie-icon/company.png",
            title: "Software product companies",
            description:
                "Our expertise supports software product companies in creating innovative & customer-centric solutions. From upgrading existing products to building new applications from scratch, we ensure your software is efficient, secure, & built to exceed market expectations. Let us handle the technical complexities while you focus on growth.",
            link: "#",
            borderClass: "border-2",
        },
        {
            icon: "/images/servie-icon/industries.svg",
            title: "Enterprises from 30+ industries",
            description:
                "We partner with enterprises across diverse industries, including healthcare, finance, education, & logistics, to deliver tailored digital solutions. By understanding each industry’s unique challenges, we build apps that drive efficiency, enhance customer engagement, & deliver measurable business impact.",
            link: "#",
            borderClass: "border-3",
        },
    ]
}

export const WhyChooseBitsclanData = {
    WhyChooseBitsclanContent: {
        mainHeading: "Why Choose Bitsclan as Your <span>Web App Development</span> Company?",
        sectionDescription: "At Bitsclan, we redefine what it means to build powerful, scalable web applications. Our expertise lies in crafting custom web app solutions that align seamlessly with your business goals. <br/> <br/> Whether it’s designing modern web apps from scratch or upgrading legacy systems, we ensure your success at every step."
    },
    WhyChooseBitsclanTabs: [
        {
            id: "Tab1",
            label: "Quality Because It Matters",
            content:
                "We prioritize quality in every line of code we write. With a focus on user experience, functionality, & performance, our web app developers deliver solutions that are secure, robust, & future-ready. Every application is rigorously tested to meet the highest industry standards.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab2",
            label: "The Best-of-the-Breed Talent",
            content:
                "Our team of web app developers is made up of innovators who excel in the latest frameworks & technologies. With extensive experience in building custom web apps, we bring creativity & technical expertise together to create web application solutions that stand out.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab3",
            label: "Time zone Alignment",
            content:
                "Working in different time zones is a thing of the past. Our team is aligned with nearshore time zones to ensure smooth communication, seamless collaboration, & timely project delivery. This guarantees no gaps in understanding or execution.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
    ]
}

export const WebServicesHighvaluesData = {
    webDevHighValueContent: {
        mainHeading: "High-Value Features for High-Performance Apps",
        sectionDescription: "Delivering exceptional web applications is about combining innovation, expertise, & functionality. At Bitsclan, we ensure your web app includes the features that drive performance, user engagement, & scalability.",
        sectionButtonText: "Consult Project Scope"
    },
    webDevHighValueCards: [
        {
            image: "custom-app-development.svg",
            text: "Custom App Development",
        },
        {
            image: "user-centric-designs.svg",
            text: "User-Centric Designs",
        },
        {
            image: "robust-architecture.svg",
            text: "Robust Architecture",
        },
        {
            image: "efficient-integration.svg",
            text: "Efficient Integration",
        },
        {
            image: "advanced-analytics.svg",
            text: "Advanced Analytics",
        },
        {
            image: "enhanced-security.svg",
            text: "Enhanced Security",
        },
        {
            image: "agile-methodology.svg",
            text: "Agile Methodology",
        },
        {
            image: "cross-platform-support.svg",
            text: "Cross-Platform Support",
        },
        {
            image: "ongoing-maintenance.svg",
            text: "Ongoing Maintenance",
        },
        {
            image: "innovation-driven-features.svg",
            text: "Innovation-Driven Features",
        },
    ]
}

export const WebServicesFaqData = {
    wePageFaqContent: {
        mainHeading: "FAQs",
        sectionDescription: "Get quick answers to your questions about our mobile app development process & services."
    },
    webServiceQuestionAnswer: [
        {
            id: "collapseOne",
            question: "What does it cost to build a web app?",
            answer:
                "The price of developing a web application depends upon its complexity, project timeline, & other factors like these. To help you understand, a simple application can be made for $1,500. On the other hand, an advanced web application with AI features can take up to $50,000 to develop.",
        },
        {
            id: "collapseTwo",
            question: "What kinds of web applications can you create?",
            answer:
                "We specialize in developing a wide range of web applications, including enterprise solutions, e-commerce platforms, customer portals, supply chain management systems, CRM/ERP systems, & more. Our expertise allows us to tailor applications to meet the specific needs of various industries.",
        },
        {
            id: "collapseThree",
            question: "How does a Progressive Web App function?",
            answer:
                "Progressive Web Apps (PWAs) combine the best of web & mobile apps. They work by utilizing modern web capabilities to deliver an app-like experience in the browser, including offline access, push notifications, & faster load times, all without needing to download from an app store.",
        },
        {
            id: "fourth",
            question: "What is the typical timeline for building a web application?",
            answer:
                "The timeline for developing a web application varies based on its complexity, features, & scope. On average, a basic web app may take 3-6 months, while more complex applications can take 6-12 months or longer, from initial discovery to final deployment.",
        },
        {
            id: "fifth",
            question: "How do you protect the security of web applications?",
            answer:
                "We prioritize security throughout the development process by implementing best practices such as encryption, secure authentication, & regular security audits. We also adhere to OWASP guidelines & ensure compliance with relevant industry standards to safeguard your web application against potential threats.",
        },
        {
            id: "sixth",
            question:
                "What should I consider when selecting a web application development company?",
            answer:
                "When choosing a web application development partner, look for a company with a strong portfolio, proven expertise in your industry, transparent communication, & a clear understanding of your business goals. It's also essential to ensure they follow best practices for security, scalability, & performance.",
        },
        {
            id: "seventh",
            question:
                "How does web application development differ from website development?",
            answer:
                "Web application development focuses on creating interactive, dynamic systems that perform complex tasks, such as user management, data processing, & real-time interaction. In contrast, website development typically involves creating static or content-driven sites that display information & may have limited interactive features.",
        },
    ]
}

export const CoverTheStack = {
    CoverTheStackContent: {
        mainHeading: "Build Scalable & High-Performance Web Apps with Expert Developers",
        sectionDescription: "At Bitsclan, we empower your web app development journey with a cutting-edge tech stack that ensures seamless performance, scalability, & innovation. Our expert developers specialize in crafting custom web applications tailored to your business needs, delivering exceptional user experiences & robust functionality.",
        defaultTabOpen: "Frontend"
    },

    tabs: [
        "Frontend",
        "Backend",
        "Libraries",
        "Database",
    ],

    tabItems: [
        { tab: "Frontend", icon: "/images/iconthree.png", name: "React JS" },
        { tab: "Frontend", icon: "/images/iconone.png", name: "Angular JS" },
        { tab: "Frontend", icon: "/images/icon7.png", name: "HTML5" },
        { tab: "Frontend", icon: "/images/icon6.png", name: "CSS3" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/gatsby.svg", name: "Gatsby" },
        { tab: "Frontend", icon: "/images/icon4.png", name: "Vue JS" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/ember.svg", name: "Ember.js" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/svelte.svg", name: "Svelte" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/backbone-js.svg", name: "Backbone.js" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/polymer.svg", name: "Polymer" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/aurelia.svg", name: "Aurelia" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/meteor.svg", name: "Meteor.js" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/next-js.svg", name: "Next.js" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/semantic.svg", name: "Semantic-UI" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/nuxt-js.svg", name: "Nuxt" },
        { tab: "Backend", icon: "/images/database9.png", name: "Node Js" },
        { tab: "Backend", icon: "/images/tech-stack-icons/elixir.svg", name: "Elixir" },
        { tab: "Backend", icon: "/images/database1.png", name: ".Net" },
        { tab: "Backend", icon: "/images/database6.png", name: "Python" },
        { tab: "Backend", icon: "/images/tech-stack-icons/ruby_on_rails.svg", name: "Ruby On Rails" },
        { tab: "Backend", icon: "/images/tech-stack-icons/java.svg", name: "Java" },
        { tab: "Backend", icon: "/images/database8.png", name: "PHP" },
        { tab: "Backend", icon: "/images/django-tech.svg", name: "Django" },
        { tab: "Backend", icon: "/images/tech-stack-icons/golang.svg", name: "Go" },
        { tab: "Backend", icon: "/images/tech-stack-icons/c-sharp.svg", name: "C#" },
        { tab: "Backend", icon: "/images/tech-stack-icons/kotlin.svg", name: "Kotlin" },
        { tab: "Backend", icon: "/images/tech-stack-icons/scala.svg", name: "Scala" },
        { tab: "Backend", icon: "/images/tech-stack-icons/rust.svg", name: "Rust" },
        { tab: "Database", icon: "/images/db5.png", name: "MySQL" },
        { tab: "Database", icon: "/images/tech-stack-icons/couchdb.svg", name: "Couch DB" },
        { tab: "Database", icon: "/images/tech-stack-icons/indexed.svg", name: "Indexed DB" },
        { tab: "Database", icon: "/images/db3.png", name: "MongoDB" },
        { tab: "Database", icon: "/images/db7.png", name: "SQLite" },
        { tab: "Database", icon: "/images/db6.png", name: "MS SQL Server" },
        { tab: "Database", icon: "/images/db1.png", name: "Firebase" },
        { tab: "Database", icon: "/images/tech-stack-icons/swift.svg", name: "Swift" },
        { tab: "Database", icon: "/images/tech-stack-icons/redis.svg", name: "Redis" },
        { tab: "Database", icon: "/images/db8.png", name: "DynamoDB" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/jquery.svg", name: "jQuery" },
        { tab: "Libraries", icon: "/images/iconthree.png", name: "React" },
        { tab: "Libraries", icon: "/images/iconone.png", name: "Angular" },
        { tab: "Libraries", icon: "/images/icon4.png", name: "Vue.js" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/vue-x.svg", name: "Vue.x" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/rx-js.svg", name: "Rxjs" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/bootstrap.svg", name: "Bootstrap" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/backbone-js.svg", name: "Backbone.js" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/ember.svg", name: "Ember.js" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/d3-js.svg", name: "D3.js" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/redux.svg", name: "Redux" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/lodash.svg", name: "Lodash" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/styled-component.svg", name: "Styled Component" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/emotion.svg", name: "Emotion" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/graphql.svg", name: "Graph QL" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/ant-design.svg", name: "Ant Design" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/inertia.svg", name: "Inertia.js" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/mobx.svg", name: "Mobx" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/web3.svg", name: "Web3" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/Web.svg", name: "WebGL" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/core-ui.svg", name: "Core UI" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/tailwind.svg", name: "Tailwind" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/material-ui.svg", name: "Material UI" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/flow-js.svg", name: "Flow.js" },
    ]
}

export const WebAppservicesRoadMap = {
    RoadMapContent: {
        mainHeading: "Our Proven Roadmap to Ensure Your Success",
        sectionDescription: "As a trusted web app development partner, we have crafted a structured roadmap to guarantee your project's success. From discovery to deployment, we align every phase with your business objectives, delivering scalable web applications, modern web apps, & tailored web application solutions. Here's how we do it:"
    },

    RoadMapHeading: [
        "Discovery & Planning",
        "Design & Proof of Concept",
        "Development & Testing",
        "Implementation & Support"
    ],
    RoadMapDescription: [
        "Every great web app starts with a solid foundation. In this phase, we work closely with you to understand your goals, define the scope, & create a strategic plan. Our web app developers ensure that your custom web apps are designed to align seamlessly with your vision & market needs.",
        "We bring your ideas to life with intuitive designs & a robust proof of concept. This step validates feasibility & ensures the scalability of your web applications, focusing on user-centric experiences & future-ready solutions.",
        "Using modern frameworks, our expert team develops high-performance web applications optimized for speed, security, & functionality. Rigorous testing ensures your custom web apps are free from errors & ready to perform under real-world conditions.",
        "We don’t just deliver—we ensure your app succeeds. From smooth deployment to continuous support, we help you optimize your scalable web applications over time, adapting to evolving business needs & keeping your solutions ahead of the curve.",
    ]
}

export const webDevPageIndustriesSection = {
    mainHeading: "Industries we serve in Web App Development"
}

export var mainBannerImg = {
    backgroundImage: `url(/images/what-we-do/web-app-development-services.avif)`,
};

export const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
        {
            "@type": "Question",
            name: "What does it cost to build a web app?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "The price of developing a web application depends upon its complexity, project timeline, & other factors like these. To help you understand, a simple application can be made for $1,500. On the other hand, an advanced web application with AI features can take up to $50,000 to develop.",
            },
        },
        {
            "@type": "Question",
            name: "What kinds of web applications can you create?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "We specialize in developing a wide range of web applications, including enterprise solutions, e-commerce platforms, customer portals, supply chain management systems, CRM/ERP systems, & more. Our expertise allows us to tailor applications to meet the specific needs of various industries.",
            },
        },
        {
            "@type": "Question",
            name: "How does a Progressive Web App function?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "Progressive Web Apps (PWAs) combine the best of web & mobile apps. They work by utilizing modern web capabilities to deliver an app-like experience in the browser, including offline access, push notifications, & faster load times, all without needing to download from an app store.",
            },
        },
        {
            "@type": "Question",
            name: "What is the typical timeline for building a web application?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "The timeline for developing a web application varies based on its complexity, features, & scope. On average, a basic web app may take 3-6 months, while more complex applications can take 6-12 months or longer, from initial discovery to final deployment.",
            },
        },
        {
            "@type": "Question",
            name: "How do you protect the security of web applications?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "We prioritize security throughout the development process by implementing best practices such as encryption, secure authentication, & regular security audits. We also adhere to OWASP guidelines & ensure compliance with relevant industry standards to safeguard your web application against potential threats.",
            },
        },
        {
            "@type": "Question",
            name: "What should I consider when selecting a web application development company?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "When choosing a web application development partner, look for a company with a strong portfolio, proven expertise in your industry, transparent communication, & a clear understanding of your business goals. It's also essential to ensure they follow best practices for security, scalability, & performance.",
            },
        },
        {
            "@type": "Question",
            name: "How does web application development differ from website development?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "Web application development focuses on creating interactive, dynamic systems that perform complex tasks, such as user management, data processing, & real-time interaction. In contrast, website development typically involves creating static or content-driven sites that display information & may have limited interactive features.",
            },
        },
    ],
};